let ApiService = (param, callback) => {
    let parameter = "";
    if (param) {
        parameter = param.query ? "?querys=" + param.query : "?noquery=0";
        parameter += param.ubigeo != null && param.ubigeo !== "00" ?"&ubigeo=" + param.ubigeo : "";
        parameter += param.marco ? "&marco=" + param.marco : "";
        parameter += param.periodo ? "&periodo=" + param.periodo : "";
        parameter += param.pnum != null ? "&pnum=" + param.pnum : "";
        parameter += param.psize != null ? "&psize=" + param.psize : "";
        parameter += param.serie != null ? "&serie=" + param.serie : "";
    }
    fetch(window.Config.API_URL + parameter)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    callback(result);
                }
            },
            (error) => {
                callback([]);
            }
        );
    return [];
};

export default ApiService;
